import React, { useState } from "react";

const BuyerAgreement = ({ isChecked, handleFormValues, hasError }) => {
  return (
    <div
      className={
        hasError
          ? "wantad-type-wrap select-type-wrap red-marked-wrap pb-0"
          : "wantad-type-wrap pb-0"
      }
    >
      <div className="row">
        <label className={hasError ? "check-wrap mb-1" : "check-wrap mb-3"}>
          <input
            type="checkbox"
            name="property_checkbox"
            checked={isChecked}
            onChange={(e) => {
              handleFormValues({ buyersAgreementSigned: e.target.checked });
            }}
          />
          <span className={hasError ? "red-marked-span" : ""}>
            <div className="wantad-type-info">
              <h2 className={hasError ? "pb-0 red-marked-subheading" : " pb-0 wanted-info-list"}>
                Buyer Agreement Form Signed
              </h2>
            </div>
          </span>
        </label>
        {hasError && (
          <span className="error-msg h-auto mb-3">
            Please confirm the buyer agreement form has been signed
          </span>
        )}
      </div>
    </div>
  );
};

export default BuyerAgreement;
